<template>
  <div>
    <!-- 价格说明 -->
    <van-dialog
      v-model="priceShow"
      confirm-button-text="我知道了"
      confirm-button-color="#3e8bf2"
    >
      <div class="content">
        <div class="title">报告价格说明</div>
        <div class="item">客户在获取当前报告时，需要支付的价格。</div>
        <div class="item">修改后，报告价格将实时生效。</div>
      </div>
    </van-dialog>
    <!-- 是否上架说明 -->
    <van-dialog
      v-model="flagShow"
      confirm-button-color="#3e8bf2"
      confirm-button-text="我知道了"
      ><div class="content">
        <div class="title">是否上架说明</div>
        <div class="item">
          该字段决定客户能否在报告获取页面看到并购买此类报告。
        </div>
        <div class="item">设为“是”：报告正常展示，客户可查看和购买。</div>
        <div class="item">
          设为“否”：报告完全隐藏，客户无法查看，也无法购买。
        </div>
      </div></van-dialog
    >
    <!-- 收益说明 -->
    <van-dialog v-model="incomeShow" confirm-button-color="#3e8bf2">
      <div class="content">
        <div class="title">收益说明（仅供参考）</div>
        <div class="item">我的收益（元） = 报告价格 - 报告成本价</div>
      </div></van-dialog
    >
  </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  data() {
    return {
      priceShow: false,
      flagShow: false,
      incomeShow: false,
    };
  },
};
</script>
<style scoped>
.content {
  font-size: 3.6vw;
  display: grid;
  padding: 4vw;
}
.title {
  color: #01224d;
  font-weight: 600;
  font-size: 4vw;
  padding-bottom: 2vw;
}
.item {
  color: #66717f;
  line-height: 7vw;
}
.item s {
  text-decoration: none;
  color: #ff7c00;
}
</style>


// WEBPACK FOOTER //
// src/view/companyRepCodeInfo/module/tipsDialog.vue